import { render, staticRenderFns } from "./references.vue?vue&type=template&id=24f2dbf2&scoped=true&"
import script from "./references.vue?vue&type=script&lang=js&"
export * from "./references.vue?vue&type=script&lang=js&"
import style0 from "./references.vue?vue&type=style&index=0&id=24f2dbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f2dbf2",
  null
  
)

export default component.exports